import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BarRatingModule } from 'ngx-bar-rating';
import { RestService } from './rest.service';
import { HeadBandComponent } from './head-band/head-band.component';
import { CustomValidator } from './customValidators';
import { SortableModule } from 'ngx-bootstrap/sortable';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TruncateModule } from 'ng2-truncate';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { HomeRoutingModule } from '../home/home-routing.module';
import { OrderByPipe, GroupByPipe} from './itinerary-sidebar/itinerary.pipes';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { RoomComponent } from './modals/modal-hotel/room/room.component';
import { DisneyRoomComponent } from './modals/modal-disney/room/room.component';
import { ModalHotelComponent } from './modals/modal-hotel/modal-hotel.component';
import { MultiDestinationComponent } from './itinerary-sidebar/categories/multi-destination/multi-destination.component';
import { SummaryFooterComponent } from './itinerary-sidebar/categories/summary-footer/summary-footer.component';
import { OptionPThemesComponent } from './modals/modal-pthemes/option-p-themes/option-p-themes.component';
import { ModalsComponent } from './modals/modals.component';
import { ModalPthemesComponent } from './modals/modal-pthemes/modal-pthemes.component';
import { ModalDisneyComponent } from './modals/modal-disney/modal-disney.component';
import { ItemHotelComponent } from './itinerary-sidebar/categories/item-hotel/item-hotel.component';
import { ItemPthemeComponent } from './itinerary-sidebar/categories/item-ptheme/item-ptheme.component';
import { ItemDisneyComponent } from './itinerary-sidebar/categories/item-disney/item-disney.component';
import { ModalTransportsComponent } from './modals/modal-transports/modal-transports.component';
import { ModalInsuranceComponent } from './modals/modal-insurance/modal-insurance.component';
import { VehicleComponent } from './modals/modal-transports/vehicle/vehicle.component';
import { ModalRentacarComponent } from './modals/modal-rentacar/modal-rentacar.component';
import { ItemTransportsComponent } from './itinerary-sidebar/categories/item-transports/item-transports.component';
import { ModalToursComponent } from './modals/modal-tours/modal-tours.component';
import { UsbItemRentacarComponent } from './itinerary-sidebar/categories/item-rentacar/item-rentacar.component';
import { ItemToursComponent } from './itinerary-sidebar/categories/item-tours/item-tours.component';
import { ItemSelectedComponent } from './item-selected/item-selected.component';
import { FlightModalComponent } from './flight-modal/flight-modal.component';
import { PaxListModalBookingComponent } from './modal-edit-booking/pax-list-modal-booking/pax-list-modal-booking.component';
import { TitleFilterPipe } from './titleFilter.pipe';
import { ItemInsuranceComponent } from './itinerary-sidebar/categories/item-insurance/item-insurance.component';
import { ModalsSearchComponent } from './modals-search/modals-search.component';
import { ModalSearchTransportsComponent } from './modals-search/modal-search-transports/modal-search-transports.component';
import { ModalPackagesComponent } from './modals/modal-packages/modal-packages.component';
import { SelectAgencyModalComponent } from './select-agency-modal/select-agency-modal.component';
import { ModalViewVideComponent } from './modal-view-video/modal-view-video.component';
import { RoomsSelectComponent } from './modal-edit-booking/rooms-select/rooms-select.component';
import { HotelRoomComponent } from './modal-edit-booking/rooms-select/hotel/hotel-room.component';
import { FormPaxesBookingComponent } from './modal-edit-booking/form-paxes-booking/form-paxes-booking.component';
import { BodyBookingComponent } from './modal-edit-booking/body-booking/body-booking.component';
import { ConfirmBookingComponent } from './modal-edit-booking/confirm-booking/confirm-booking.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { MaterialModalConfirmComponent } from './material-modal-confirm/material-modal-confirm.component';
import { NrPrepaymentModalComponent } from './nr-prepayment-modal/nr-prepayment-modal.component';
import { FidelityService } from '../fidelity/fidelity.service';
import { NrBlockModalComponent } from './nr-block-modal/nr-block-modal.component';
import { AgentsService } from '../agents/agents.service';
import { AgentsSummaryService } from '../agents-summary/agents-summary.service';

import { ModalPostBookingComponent } from './modal-post-booking/modal-post-booking.component';
import { SelectItemsComponent } from './modal-post-booking/select-items/select-items.component';
import { ConfirmItemsComponent } from './modal-post-booking/confirm-items/confirm-items.component';
import { PaymentItemsComponent } from './modal-post-booking/payment-items/payment-items.component';
import { DocumentationComponent } from './modal-post-booking/documentation/documentation.component';
import { MaterialModalAlertComponent } from './material-modal-alert/material-modal-alert.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ItinerarySidebarComponent } from './itinerary-sidebar/itinerary-sidebar.component';
import { ItineraryOwnerComponent } from './itinerary-owner/itinerary-owner.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxPayPalModule } from 'ngx-paypal';
import { MatExpansionModule} from '@angular/material/expansion';
import { MatIconModule} from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ToastrModule } from 'ngx-toastr';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { MatFormFieldModule } from '@angular/material/form-field';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
import { AuthorizationService } from 'app/core/authorization/authorization.service';
import { DailyPricesComponent } from './modals/modal-hotel/room/daily-prices/daily-prices.component';
import { FilterMannagementComponent } from './filter-mannagement/filter-mannagement.component';
import { ScrollToTopDirectiveDirective } from './scroll-to-top-directive.directive';
import { LoadingSplashDirective } from './directives/loading-splash.directive';
import { ModalLoadingComponent } from './modal-loading/modal-loading.component';
import { UsbPopupComponent } from './usb-popup/usb-popup.component';
import { DynamicFontSizePipe } from './dynamic-font-size.pipe';
import { LazyLoadImageDirective } from './directives/LazyLoadImage.directive';
import { RequestBilledFormComponent } from './modal-post-booking/request-billed-form/request-billed-form.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SuggestionComponent } from './suggestion/suggestion.component';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { VehicleInfoTransferComponent } from './modals/modal-transports/vehicle/vehicle-info-transfer/vehicle-info-transfer.component';
import { FormOfflineComponent } from './form-offline/form-offline.component';
import { WheelTimePickerComponent } from './wheel-time-picker/wheel-time-picker.component';
import { CommentsComponent } from './modals/comments/comments.component';
import { InformationComponent } from './modals/information/information.component';
import { PhotosComponent } from './modals/modal-hotel/photos/photos.component';

import { InsuranceQuoteModalComponent } from './modals/insurance-quote/insurance-quote-modal.component';
import { CurrencyConverterPurePipe } from './currency-converter-pure.pipe';
import { FormFlightInternalComponent } from './flight-modal/form-flight-internal/form-flight-internal.component';
import { TooltipConvertAmountModule } from './tooltip-convert-amount/tooltip-convert-amount.module';
import { TransportsService } from './modals/modal-transports/transports.service';
import { HotelService } from './modals/modal-hotel/hotel.service';
import { NavbarSearchCategoriesComponent } from './navbar-search-categories/navbar-search-categories.component';
import { MapViewComponent } from './map-view/map-view.component';
import { UsbBaseModalComponent } from './usb-base-modal/usb-base-modal.component';
import { ConfirmationModalComponent } from './modals/confirmation-modal/confirmation-modal.component';
import { NotFoundModalComponent } from './modals/not-found-modal/not-found-modal.component';
import { DeleteTransferModalComponent } from './modals/delete-transfer-modal/delete-transfer-modal.component';
import { ClientListModalComponent } from './modals/client-list-modal/client-list-modal.component';
import { VerificationModalComponent } from './modals/verification-modal/verification-modal.component';
import { ReservingModalComponent } from './modals/reserving-modal/reserving-modal.component';
import { ConnectingModalComponent } from './modals/connecting-modal/connecting-modal.component';
import { CancelModalComponent } from './modals/cancel-modal/cancel-modal.component';
import { EditSearchModalComponent } from './modals/edit-search-modal/edit-search-modal.component';
import { SellerSelectModalComponent } from './modals/seller-select-modal/seller-select-modal.component';
import { CartModule } from './cart/cart.module';
import { CartSidebarComponent } from './cart/components/cart-sidebar/cart-sidebar.component';
import { AccordionInfoProductComponent } from './modals-results-categories/accordion-info-product/accordion-info-product.component';
import { RoomDetailComponent } from './modals/modal-hotel/room/room-detail/room-detail.component';
import { RoomExtrasComponent } from './modals/modal-hotel/room/room-extras/room-extras.component';
import { CancellationPoliciesComponent } from './modals-results-categories/cancellation-policies/cancellation-policies.component';
import { TabButtonsComponent } from './modals-results-categories/tab-buttons/tab-buttons.component';
import { BaseResultsCategoriesComponent } from './modals-results-categories/base-results-categories/base-results-categories.component';
import { SecureImageDirective } from './directives/SecureImageDirective.directive';
import { NotificationContainerComponent } from './notifications/notificationContainer/notificationContainer';
import { NotificationItemComponent } from './notifications/notificationItem/notificationItem';

defineLocale('es', esLocale);
registerLocaleData(localeEs, 'es');

@NgModule({
  imports: [
    CommonModule,
    NguiAutoCompleteModule,
    FormsModule,
    ReactiveFormsModule,
    BarRatingModule,
    SortableModule.forRoot(),
    TabsModule.forRoot(),
    CollapseModule.forRoot(),
    RatingModule.forRoot(),
    ModalModule.forRoot(),
    CarouselModule,
    ToastrModule.forRoot(),
    TimepickerModule.forRoot(),
    TruncateModule,
    HomeRoutingModule,
    BsDatepickerModule.forRoot(),
    MatDialogModule,
    MatProgressSpinnerModule,
    NgxPaginationModule,
    NgxSpinnerModule,
    NgxSpinnerModule,
    NgxPayPalModule,
    MatIconModule,
    MatExpansionModule,
    NgxDaterangepickerMd,
    AccordionModule.forRoot(),
    AngularSvgIconModule.forRoot(),
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    TypeaheadModule.forRoot(),
    TooltipModule,
    CartModule,
    TooltipConvertAmountModule
  ],
  declarations: [
    TitleFilterPipe,
    HeadBandComponent,
    CustomValidator,
    ItinerarySidebarComponent,
    OrderByPipe,
    GroupByPipe,
    ItineraryOwnerComponent,
    ModalHotelComponent,
    RoomComponent,
    DisneyRoomComponent,
    MultiDestinationComponent,
    SummaryFooterComponent,
    OptionPThemesComponent,
    ModalsComponent,
    ModalPthemesComponent,
    ModalDisneyComponent,
    ItemHotelComponent,
    ItemPthemeComponent,
    ItemDisneyComponent,
    ModalTransportsComponent,
    VehicleComponent,
    ModalInsuranceComponent,
    ModalRentacarComponent,
    ItemTransportsComponent,
    ItemInsuranceComponent,
    ItemToursComponent,
    UsbItemRentacarComponent,
    ItemSelectedComponent,
    FlightModalComponent,
    PaxListModalBookingComponent,
    FormPaxesBookingComponent,
    BodyBookingComponent,
    ConfirmBookingComponent,
    RoomsSelectComponent,
    ModalsSearchComponent,
    ModalSearchTransportsComponent,
    ModalPackagesComponent,
    SelectAgencyModalComponent,
    ModalViewVideComponent,
    HotelRoomComponent,
    MaterialModalConfirmComponent,
    NrPrepaymentModalComponent,
    NrBlockModalComponent,
    ModalPostBookingComponent,
    SelectItemsComponent,
    ConfirmItemsComponent,
    PaymentItemsComponent,
    DocumentationComponent,
    MaterialModalAlertComponent,
    DailyPricesComponent,
    FilterMannagementComponent,
    ScrollToTopDirectiveDirective,
    LoadingSplashDirective,
    ModalLoadingComponent,
    UsbPopupComponent,
    DynamicFontSizePipe,
    LazyLoadImageDirective,
    RequestBilledFormComponent,
    SuggestionComponent,
    VehicleInfoTransferComponent,
    FormOfflineComponent,
    CommentsComponent,
    InformationComponent,
    PhotosComponent,
    CurrencyConverterPurePipe,
    FormFlightInternalComponent,
    NavbarSearchCategoriesComponent,
    MapViewComponent,
    UsbBaseModalComponent,
    ConfirmationModalComponent,
    NotFoundModalComponent,
    WheelTimePickerComponent,
    DeleteTransferModalComponent,
    ClientListModalComponent,
    ModalToursComponent,
    VerificationModalComponent,
    ReservingModalComponent,
    ConnectingModalComponent,
    CancelModalComponent,
    EditSearchModalComponent,
    CancellationPoliciesComponent,
    AccordionInfoProductComponent,
    RoomDetailComponent,
    RoomExtrasComponent,
    TabButtonsComponent,
    SellerSelectModalComponent,
    BaseResultsCategoriesComponent,
    InsuranceQuoteModalComponent,
    SecureImageDirective,
    CapitalizePipe,
    NotificationContainerComponent,
    NotificationItemComponent,
  ],
  providers: [
    RestService,
    DatePipe,
    FidelityService,
    AgentsService,
    AgentsSummaryService,
    AuthorizationService,
    TransportsService,
    HotelService
  ],
  exports: [
    ItineraryOwnerComponent,
    HeadBandComponent,
    ItinerarySidebarComponent,
    ModalsComponent,
    ModalsSearchComponent,
    ModalSearchTransportsComponent,
    ItemSelectedComponent,
    TitleFilterPipe,
    PaxListModalBookingComponent,
    FormPaxesBookingComponent,
    BodyBookingComponent,
    ConfirmBookingComponent,
    RoomsSelectComponent,
    FilterMannagementComponent,
    ScrollToTopDirectiveDirective,
    LoadingSplashDirective,
    ModalLoadingComponent,
    UsbPopupComponent,
    DynamicFontSizePipe,
    LazyLoadImageDirective,
    SuggestionComponent,
    FlightModalComponent,
    PhotosComponent,
    CurrencyConverterPurePipe,
    NavbarSearchCategoriesComponent,
    MapViewComponent,
    UsbBaseModalComponent,
    ConfirmationModalComponent,
    NotFoundModalComponent,
    WheelTimePickerComponent,
    DeleteTransferModalComponent,
    ClientListModalComponent,
    ModalToursComponent,
    VerificationModalComponent,
    ReservingModalComponent,
    ConnectingModalComponent,
    CancelModalComponent,
    EditSearchModalComponent,
    CartSidebarComponent,
    CancellationPoliciesComponent,
    AccordionInfoProductComponent,
    TooltipConvertAmountModule,
    SecureImageDirective,
    CapitalizePipe,
    NotificationContainerComponent,
    NotificationItemComponent,
  ],
  entryComponents: [
    SelectAgencyModalComponent,
    ModalViewVideComponent,
    HotelRoomComponent,
    ModalPthemesComponent,
    ModalHotelComponent,
    OptionPThemesComponent,
    RoomComponent,
    ModalPackagesComponent,
    MaterialModalConfirmComponent,
    ConfirmationModalComponent,
    NotFoundModalComponent,
    DeleteTransferModalComponent,
    ClientListModalComponent,
    NrPrepaymentModalComponent,
    NrBlockModalComponent,
    ModalsComponent,
    MaterialModalAlertComponent,
    VerificationModalComponent,
    ReservingModalComponent,
    ConnectingModalComponent,
    CancelModalComponent,
    EditSearchModalComponent,
    SellerSelectModalComponent,
    InsuranceQuoteModalComponent
  ]
})
export class SharedModule { }
